import {
  Button,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@vesyl/ui'
import { Text } from '@vesyl/ui/chakra'
import type { ReactNode } from 'react'

interface DialogAlertProps {
  open: boolean
  setOpen: (open: boolean) => void

  onConfirm?: () => void | Promise<void>
  title?: string
  message?: ReactNode
  confirmText?: string
  cancelText?: string
  type?: 'danger' | 'default'
  loading?: boolean
}

export function AlertDialog(props: DialogAlertProps) {
  const {
    open,
    setOpen,
    onConfirm,
    title = 'Confirm action',
    message = 'Are you sure you want to continue? This action cannot be undone.',
    confirmText = 'Yes, continue',
    cancelText = 'Cancel',
    type = 'danger',
    loading = false,
  } = props

  const handleConfirm = async () => {
    await onConfirm?.()
    setOpen(false)
  }

  const colorPalette = type === 'danger' ? 'red' : undefined

  return (
    <DialogRoot open={open} onOpenChange={(e) => setOpen(e.open)} role="alertdialog">
      <DialogContent>
        <DialogCloseTrigger disabled={loading} />
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {typeof message === 'string' ? <Text color="fg.muted">{message}</Text> : message}
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)} disabled={loading}>
            {cancelText}
          </Button>
          <Button onClick={handleConfirm} loading={loading} colorPalette={colorPalette}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}
